import React from "react"
// Material Ui
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"
import { defineMessages, useIntl } from "react-intl"
import useLoginStyles from "./loginStyle"

const messages = defineMessages({
  welcome: {
    id: "login.welcome",
    defaultMessage: "Welcome"
  },
  customerSubText: {
    id: "login.customer.text",
    defaultMessage: "Dear customer"
  }
})

const LoginText = () => {
  const { formatMessage: format } = useIntl()
  const classes = useLoginStyles()
  return (
    <Box className={classes.loginText}>
      <Typography variant="h1" color="textPrimary">
        {format(messages.welcome)}
      </Typography>
      <Typography variant="h2" color="textSecondary">
        {format(messages.customerSubText)}
      </Typography>
    </Box>
  )
}

export default LoginText
